import {API} from "./API";
import {Utility} from "../core/Utility";
import {LoggerService} from "../core/logger/LoggerService";
import {Tenant} from "../models/Tenant";

export class TenantAPI extends API<Tenant> {

	constructor () {
		super("tenant");
    }

	public get (): Promise<any> {
		let url = `/${this.endpoint}`;
		return API.axiosInstance.get(url);
	}

	public put (item: Tenant): Promise<any> {
		if (Utility.isNullOrUndefined(item.id)) LoggerService.addError("Id not defined");
		let url = `/${this.endpoint}`;
		let payload = item;
		return API.axiosInstance.put(url, payload);
	}
}
